import styled from 'styled-components';

import theme from '../../theme';

export const DownloadTemplateContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${theme.colors.white};
  padding: 30px 20px;

  @media (max-width: ${theme.breakpoints.md}) {
    background-color: ${theme.colors.lighterBackground};
  }

  & .table-container {
    margin-bottom: 20px;
  }
`;
export const DownloadTemplateTableStyled = styled.div`
  margin-top: 18px;

  & .table-container {
    margin-bottom: 20px;
  }
  & .flag {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 12px;
    margin-bottom: -5px;
  }

  & .templeteFile {
    display: flex;
    align-items: center;
    justify-content: center;

    & .templeteFileImage {
      width: 44px;
      height: 33px;
    }
  }
  @media (max-width: ${theme.breakpoints.md}) {
    & .data-row .actions button {
      background-color: transparent;
      color: ${theme.colors.secondary};
      border: 0px;
    }
  }
`;
